export function storeLink(value: string | null | undefined, platform: "ios" | "android") {
  if (!value) return null;
  try {
    const url = new URL(value);
    const hostname = platform === "ios" ? "apps.apple.com" : "play.google.com";
    if (url.protocol !== "https:" || url.hostname !== hostname || url.username || url.password || url.port || url.href.includes("#") || url.href.length > 2048)
      return null;
    if (platform === "ios" && !/^\/(?:[a-z]{2}\/)?app\/(?:[^/]+\/)?id\d+\/?$/.test(url.pathname)) return null;
    if (platform === "android" && (url.pathname !== "/store/apps/details" || url.searchParams.getAll("id").length !== 1 || !url.searchParams.get("id")?.trim())) return null;
    return url.href;
  } catch {
    return null;
  }
}
